import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LotBuildProgrammeNgJsService {
    public readonly REFRESH_BUILD_PROGRAMME = new Subject();
}
